import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IReferralSavePatientTreatments, IReferralTreatment, IReferralTreatmentCode } from "../models/IReferral";

export class ReferralTreatmentReportingApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    getReferralTreatments(id: string, success: (data: IReferralTreatment[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IReferralTreatment[]>(`${Utils.LIB_API_BASE_URL}/referral/treatmentReporting/referralTreatments/${id}`, success, error, final);
    }

    getReferralTreatmentCodes(referralId: number, success: (data: IReferralTreatmentCode[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IReferralTreatmentCode[]>(`${Utils.LIB_API_BASE_URL}/referral/treatmentReporting/referralTreatmentCodes/${referralId}`, success, error, final);
    }

    saveReferralTreatment(data: IReferralSavePatientTreatments, success: () => void, error: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/referral/treatmentReporting/referralTreatment/`, data, success, error, final);
    }

    deleteReferralTreatment(patientTreatmentId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/referral/treatmentReporting/referralTreatment/${patientTreatmentId}`, success, error, final);
    }

    creditTreatment(patientTreatmentId: number, success: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/referral/treatmentReporting/creditTreatment/${patientTreatmentId}`, undefined, success);
    }

}